import {Injectable} from "@angular/core";
import {Http, URLSearchParams} from "@angular/http";
import {AuthentService} from "../authent.service";
import {Business} from "../../model/business";
import {Observable} from "rxjs/Rx";
import {UrlService} from "../url.service";
import {FamiliesService} from "../families.service";
import {FamilyAlbum} from "../../model/family-album";
import {Page} from "../../model/page";
import {Picture} from "../../model/picture";
import {BusinessRight} from "../../model/business-right";
import {AdminForm} from "../../components/admin/admin-form.model";
import {BusinessTransaction} from "../../model/business-transaction";
import {EmailError} from "./errors/email-error";
import {ContactRequest} from "../../model/contact-request";
import {BusinessBill} from "../../model/bill/business-bill";
import {User} from "../../model/user";
import {Tweet} from "../../model/social/tweet";

@Injectable()
export class BusinessService extends FamiliesService {

  constructor(private http:Http, private authent:AuthentService, private urlService:UrlService) {
    super();
  }

  getBusiness(businessId:number) {
    return this.http.get(this.urlService.getBusinessUrl(businessId), this.authent.getJSONAuthentHeaders())
      .map(this.extractData)
      .catch(this.handleError);
  }

  getBusinesses():Observable<Business[]> {
    return this.http.get(this.urlService.getBusinessesUrl(), this.authent.getJSONAuthentHeaders())
      .map(this.extractData)
      .catch(this.handleError);
  }

  createBusiness(business:Business):Observable<Business> {
    return this.http.post(this.urlService.getBusinessesUrl(), business, this.authent.getJSONAuthentHeaders())
      .map(this.extractData)
      .catch(this.handleError);
  }

  updateBusiness(business:Business):Observable<Business> {
    return this.http.put(this.urlService.getBusinessesUrl(), business, this.authent.getJSONAuthentHeaders())
      .map(this.extractData)
      .catch(this.handleError);
  }

  getEvent(eventId:number):Observable<FamilyAlbum> {
    return this.http.get(this.urlService.getEventUrl(eventId), this.authent.getJSONAuthentHeaders())
      .map(this.extractData)
      .catch(this.handleError);
  }

  getPublicEvent(eventId:number):Observable<FamilyAlbum> {
    return this.http.get(this.urlService.getPublicEventUrl(eventId), this.authent.getJSONAuthentHeaders())
      .map(this.extractData)
      .catch(this.handleError);
  }

  deleteEvent(eventId:number) {
    return this.http.delete(this.urlService.getEventUrl(eventId), this.authent.getAuthentHeaders());
  }

  getEvents(businessId:number, page:number, pageSize:number):Observable<Page<FamilyAlbum>> {
    let params:URLSearchParams = new URLSearchParams();
    params.set('page', String(page));
    params.set('pageSize', String(pageSize));

    let options = this.authent.getJSONAuthentHeaders();
    options.search = params;

    return this.http.get(this.urlService.getBusinessEventsUrl(businessId), options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  createEvent(businessId:number, event:FamilyAlbum) {
    return this.http.post(this.urlService.getBusinessEventsUrl(businessId), event, this.authent.getJSONAuthentHeaders())
      .map(this.extractData)
      .catch(this.handleError);
  }

  updateCover(eventId:number, pictureId:number) {
    return this.http.put(this.urlService.getUpdateEventCoverUrl(eventId, pictureId), null, this.authent.getJSONAuthentHeaders())
      .map(this.extractData)
      .catch(this.handleError);
  }

  eventPictures(eventId:number, page:number, pageSize:number):Observable<Page<Picture>> {
    let params:URLSearchParams = new URLSearchParams();
    params.set('page', String(page));
    params.set('pageSize', String(pageSize));

    let options = this.authent.getJSONAuthentHeaders();
    options.search = params;

    return this.http.get(this.urlService.getEventPicturesUrl(eventId), options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  eventTweets(eventId:number, page:number, pageSize:number):Observable<Page<Tweet>> {
    let params:URLSearchParams = new URLSearchParams();
    params.set('page', String(page));
    params.set('pageSize', String(pageSize));

    let options = this.authent.getJSONAuthentHeaders();
    options.search = params;

    return this.http.get(this.urlService.getEventTweetsUrl(eventId), options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  eventPicturesToModerate(eventId:number, page:number, pageSize:number):Observable<Page<Picture>> {
    let params:URLSearchParams = new URLSearchParams();
    params.set('page', String(page));
    params.set('pageSize', String(pageSize));

    let options = this.authent.getJSONAuthentHeaders();
    options.search = params;

    return this.http.get(this.urlService.getEventPicturesUrlToModerate(eventId), options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  eventTweetsToModerate(eventId:number, page:number, pageSize:number):Observable<Page<Tweet>> {
    let params:URLSearchParams = new URLSearchParams();
    params.set('page', String(page));
    params.set('pageSize', String(pageSize));

    let options = this.authent.getJSONAuthentHeaders();
    options.search = params;

    return this.http.get(this.urlService.getEventTweetsUrlToModerate(eventId), options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  moderateRefusePictures(eventId:number, pictureIds) {
    return this.http.post(this.urlService.getEventModerateRefusePictures(eventId), pictureIds, this.authent.getJSONAuthentHeaders());
  }

  moderateAcceptPictures(eventId:number, pictureIds) {
    return this.http.post(this.urlService.getEventModerateAcceptPictures(eventId), pictureIds, this.authent.getJSONAuthentHeaders());
  }

  moderateRefuseTweets(eventId:number, tweetIds) {
    return this.http.post(this.urlService.getEventModerateRefuseTweets(eventId), tweetIds, this.authent.getJSONAuthentHeaders());
  }

  moderateAcceptTweets(eventId:number, tweetIds) {
    return this.http.post(this.urlService.getEventModerateAcceptTweets(eventId), tweetIds, this.authent.getJSONAuthentHeaders());
  }

  publicEventPictures(eventId:number, page:number, pageSize:number):Observable<Page<Picture>> {
    let params:URLSearchParams = new URLSearchParams();
    params.set('page', String(page));
    params.set('pageSize', String(pageSize));

    let options = this.authent.getJSONAuthentHeaders();
    options.search = params;

    return this.http.get(this.urlService.getPublicEventPicturesUrl(eventId), options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  deleteEventPictures(eventId:number, pictureIds:number[]):any {
    return this.http.delete(this.urlService.getDeleteEventPictures(eventId, pictureIds), this.authent.getJSONAuthentHeaders())
      .catch(this.handleError);
  }

  getAdmins(businessId:number):Observable<BusinessRight[]> {
    return this.http.get(this.urlService.getBusinessAdminsUrl(businessId), this.authent.getJSONAuthentHeaders())
      .map(this.extractData)
      .catch(this.handleError);
  }

  addAdmin(businessId:number, invitation:AdminForm):Observable<any> {
    return this.http.post(this.urlService.getBusinessAdminsUrl(businessId), invitation, this.authent.getJSONAuthentHeaders())
      .map(this.extractData)
      .catch(this.handleError);
  }

  removeMember(eventId:number, memberId:number) {
    return this.http.delete(this.urlService.getRemoveMemberUrl(eventId, memberId), this.authent.getAuthentHeaders())
      .catch(this.handleError);
  }

  inviteMembers(eventId:number, emails:string):Observable<EmailError[]> {
    return this.http.post(this.urlService.getInviteMemberUrl(eventId), emails, this.authent.getJSONAuthentHeaders())
      .map(this.extractData)
      .catch(this.handleError);
  }

  updateEvent(event:FamilyAlbum):Observable<FamilyAlbum> {
    return this.http.put(this.urlService.getEventUrl(event.id), event, this.authent.getJSONAuthentHeaders())
      .map(this.extractData)
      .catch(this.handleError);
  }

  getRight(businessId:number):Observable<BusinessRight> {
    return this.http.get(this.urlService.getBusinessRightUrl(businessId), this.authent.getJSONAuthentHeaders())
      .map(this.extractData)
      .catch(this.handleError);
  }

  updateRight(right:BusinessRight):Observable<BusinessRight> {
    return this.http.put(this.urlService.getUpdateBusinessRightUrl(), right, this.authent.getJSONAuthentHeaders())
      .map(this.extractData)
      .catch(this.handleError);
  }

  removeAdmin(businessId:number, adminId:number):Observable<any> {
    return this.http.delete(this.urlService.getBusinessRemoveAdminUrl(businessId, adminId), this.authent.getAuthentHeaders())
      .catch(this.handleError);
  }

  createTransaction(businessId:number):Observable<BusinessTransaction> {
    return this.http.get(this.urlService.getCreateBusinessTransactionUrl(businessId), this.authent.getJSONAuthentHeaders())
      .map(this.extractData)
      .catch(this.handleError);
  }

  sendOnlineContact(contactRequest:ContactRequest, businessId: number) {
    return this.http.post(this.urlService.getSendBusinessContactUrl(businessId), contactRequest, this.authent.getJSONAuthentHeaders())
        .catch(this.handleError);
  }

  getBills(businessId:number):Observable<BusinessBill[]> {
    return this.http.get(this.urlService.getBusinessBillsUrl(businessId), this.authent.getJSONAuthentHeaders())
        .map(this.extractData)
        .catch(this.handleError);
  }

  sendActivationEmail(businessId:number) {
    return this.http.post(this.urlService.getSendActivationEmailUrl(businessId), null, this.authent.getJSONAuthentHeaders())
        .catch(this.handleError);
  }

  activateBusiness(code:string, businessId:number) {
    return this.http.post(this.urlService.getActivateEmailUrl(code, businessId), null, this.authent.getJSONAuthentHeaders())
        .catch(this.handleError);
  }

  getWallPictures(eventId:number): Observable<Picture[]> {
    return this.http.get(this.urlService.getWallPicturesUrl(eventId), this.authent.getJSONAuthentHeaders())
      .map(this.extractData)
      .catch(this.handleError);
  }

  getLastWallPictures(eventId:number, date: number): Observable<Picture[]> {
    let params:URLSearchParams = new URLSearchParams();
    params.set('date', String(date));

    let options = this.authent.getJSONAuthentHeaders();
    options.search = params;

    return this.http.get(this.urlService.getLastWallPicturesUrl(eventId), options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  getPublicWallPictures(eventId:number): Observable<Picture[]> {
    return this.http.get(this.urlService.getPublicWallPicturesUrl(eventId), this.authent.getJSONAuthentHeaders())
      .map(this.extractData)
      .catch(this.handleError);
  }

  getPublicLastWallPictures(eventId:number, date: number): Observable<Picture[]> {
    let params:URLSearchParams = new URLSearchParams();
    params.set('date', String(date));

    let options = this.authent.getJSONAuthentHeaders();
    options.search = params;

    return this.http.get(this.urlService.getPublicLastWallPicturesUrl(eventId), options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  loadOldMembers(businessId:number, page:number, pageSize:number):Observable<Page<User>> {

    let params:URLSearchParams = new URLSearchParams();
    params.set('page', String(page));
    params.set('pageSize', String(pageSize));

    let options = this.authent.getJSONAuthentHeaders();
    options.search = params;

    return this.http.get(this.urlService.getBusinessOldMemberUrl(businessId), options)
        .map(this.extractData)
        .catch(this.handleError);
  }

  inviteOldMembers(eventId: number, memberIds: Array<number>) {
    return this.http.post(this.urlService.getInviteOldMembersUrl(eventId), memberIds, this.authent.getJSONAuthentHeaders())
      .catch(this.handleError);
  }

  inviteAllOldMembers(eventId: number, businessId: number) {
    return this.http.post(this.urlService.getInviteAllOldMembersUrl(eventId, businessId), null, this.authent.getJSONAuthentHeaders())
      .catch(this.handleError);
  }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader?{"configFile":"tslint.json"}!./src/app/services/data/business.service.ts